import type { ExperienceCapabilityV2, ExperienceConfigSchemaV2, ExperienceNodeV2, ExperienceScreenStateV2 } from 'sdui-core'

const schemaDefault = (schema: ExperienceConfigSchemaV2): unknown => {
  if (schema.default !== undefined) return structuredClone(schema.default)
  if (schema.type === 'object')
    return Object.fromEntries(Object.entries(schema.properties).map(([key, child]) => [key, schemaDefault(child)]))
  if (schema.type === 'array') return []
  return undefined
}

const merge = (base: unknown, overrides: unknown): unknown => {
  if (!base || typeof base !== 'object' || Array.isArray(base) || !overrides || typeof overrides !== 'object' || Array.isArray(overrides)) {
    return overrides === undefined ? base : overrides
  }
  return Object.fromEntries(
    [...new Set([...Object.keys(base), ...Object.keys(overrides)])].map(key => [
      key,
      merge((base as Record<string, unknown>)[key], (overrides as Record<string, unknown>)[key]),
    ])
  )
}

export const nodeV2 = (
  definitions: Readonly<Record<string, ExperienceCapabilityV2>>,
  capability: string,
  options: {
    readonly children?: readonly string[]
    readonly config?: Readonly<Record<string, unknown>>
    readonly requires?: readonly string[]
    readonly enabled?: boolean
  } = {}
): ExperienceNodeV2 => {
  const definition = definitions[capability]
  if (!definition) throw new Error(`Unknown V2 capability ${capability}`)
  return {
    capability,
    capabilityVersion: definition.version.current,
    config: merge(schemaDefault(definition.configSchema), options.config ?? {}) as Record<string, unknown>,
    children: [...(options.children ?? [])],
    visibility: {
      enabled: options.enabled ?? true,
      ...(options.requires?.length ? { requires: [...options.requires] } : {}),
    },
  }
}

export const readyStateV2 = (root: string, elements: Record<string, ExperienceNodeV2>): { states: { ready: ExperienceScreenStateV2 } } => ({
  states: { ready: { root, elements } },
})
